module.exports = __webpack_public_path__ + "static/media/nextUp.dceab942.svg";